import { MessageCircle, MapPin, ShieldCheck } from "lucide-react";
import { LOGO_URL, KEYWORDS, MAPS_LINK, WA_DISPLAY, waLink } from "@/data/site";

const NAV = [
  { href: "#beranda", label: "Beranda" },
  { href: "#tentang", label: "Tentang Kami" },
  { href: "#keunggulan", label: "Keunggulan" },
  { href: "#katalog", label: "Katalog Produk" },
  { href: "#kalkulator", label: "Kalkulator Kayu" },
  { href: "#lokasi", label: "Lokasi" },
];

const INK = "#FFFFFF";
const INK_SOFT = "#FBD3E4";
const LINE = "rgba(255,255,255,0.28)";

const LEGAL_ITEMS = [
  "Terdaftar Resmi & Berlegalitas Lengkap",
  "NIB: 12102600676430001",
  "SK Kemenkumham: AHU-A130438.AH.01.30.Tahun 2026",
  "NPWP: 1000 0000 1152 3665",
];

export const Footer = () => (
  <footer
    data-testid="footer"
    className="relative overflow-hidden pt-20"
    style={{ background: "linear-gradient(160deg, #0D9488 0%, #0B6B60 55%, #07554C 100%)" }}
  >
    <div
      className="overflow-hidden border-y py-4"
      style={{ borderColor: LINE }}
      data-testid="legality-section"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap" style={{ animationDuration: "70s" }}>
        {[0, 1].map((copy) => (
          <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
            {[...LEGAL_ITEMS, ...LEGAL_ITEMS].map((item, i) => (
              <span key={`${copy}-${i}`} className="flex items-center">
                <ShieldCheck size={15} style={{ color: INK }} />
                <span className="mx-3 font-serif text-base font-semibold italic" style={{ color: INK }}>
                  {item}
                </span>
                <span style={{ color: "rgba(251,211,228,0.55)" }}>✦</span>
                <span className="mx-3" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>

    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <p
        className="pointer-events-none select-none whitespace-nowrap text-center font-serif text-[13vw] font-bold leading-none lg:text-[9rem]"
        style={{ color: "transparent", WebkitTextStroke: "1px rgba(249,168,212,0.45)" }}
        aria-hidden="true"
      >
        AL MUBAROKAH
      </p>

      <div className="mt-16 grid gap-12 pb-16 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Logo PT. SINAR AL MUBAROKAH" className="h-12 w-12 rounded-xl object-cover ring-2" style={{ "--tw-ring-color": INK }} />
            <p className="font-serif text-lg font-semibold" style={{ color: INK }}>PT. SINAR<br />AL MUBAROKAH</p>
          </div>
          <p className="mt-5 text-sm leading-relaxed" style={{ color: INK_SOFT }}>
            Distributor utama kayu olahan & triplek berkualitas tinggi Indonesia. Legal, presisi, dan harga grosir langsung pabrik.
          </p>
        </div>
        <div>
          <p className="overline-label mb-5" style={{ color: INK }}>Navigasi</p>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.href}>
                <a href={n.href} className="text-sm transition-colors hover:underline" style={{ color: INK_SOFT }}>
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="overline-label mb-5" style={{ color: INK }}>Produk Populer</p>
          <div className="flex flex-wrap gap-2">
            {KEYWORDS.slice(0, 10).map((k) => (
              <span key={k} className="rounded-full border px-3 py-1 text-[10px]" style={{ borderColor: LINE, color: INK_SOFT }}>
                {k}
              </span>
            ))}
          </div>
        </div>
        <div>
          <p className="overline-label mb-5" style={{ color: INK }}>Hubungi Kami</p>
          <a
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-sm font-semibold hover:underline"
            style={{ color: INK }}
          >
            <MessageCircle size={16} /> {WA_DISPLAY}
          </a>
          <a
            href={MAPS_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 flex items-center gap-2 text-sm transition-colors hover:underline"
            style={{ color: INK_SOFT }}
          >
            <MapPin size={16} /> Lihat Lokasi di Google Maps
          </a>
        </div>
      </div>

      <div
        className="flex flex-col items-center justify-between gap-3 border-t py-7 text-xs sm:flex-row"
        style={{ borderColor: LINE, color: INK_SOFT }}
      >
        <p>© 2026 PT. SINAR AL MUBAROKAH. Seluruh hak cipta dilindungi.</p>
        <p>Distributor Kayu Olahan & Triplek — Indonesia</p>
      </div>
    </div>
  </footer>
);
